/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTypeTargetSpecOptions } from './rolloutTypeTargetSpecOptions';
import { RolloutType } from './rolloutType';


/**
 * Configuration for a specific rollout option
 */
export interface RolloutTypeOptionsSpec { 
    rollout_type: RolloutType;
    target_spec_options: RolloutTypeTargetSpecOptions;
}
export namespace RolloutTypeOptionsSpec {
}


